


















import api from '@/lib/api';
import Vue from 'vue'
export default Vue.extend({
    data(){
        return {
            title: '',
            description: '',
            current_file: {} as File,
            message: ''
        }
    },
    methods: {
        loadFile(){
            document.getElementById('pdf')!.click();
        },
        setFile(){
            const input = document.getElementById('pdf')! as HTMLInputElement;
            if(!input.files) return;

            this.current_file = input.files[0];
        },
        async upload(){

            this.message = "";
            if(!this.title || !this.current_file.size) return this.message = "titolo e pdf obbligatorii"
            
            const url = await api.media.articles.getSignedUrl();
            if(url.err) return alert("di' a cippi che è successo un casino");

            await fetch(url.ok!.value.url, {
                method: "PUT",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                body: this.current_file
            });

            const res = await api.media.articles.upload(url.ok!.value.filename, this.title, this.description);
            if(res.err) return alert("di' a cippi che è successo un casino");

            this.message = 'pogchamp'

        }
    }
})
